
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"xmlns":"http://www.w3.org/2000/svg","viewBox":"0 0 60.996 60.996"}, attrs),
              ...rest,
            },
            children.concat([_c('g',{attrs:{"fill":"#ff6959"}},[_c('circle',{attrs:{"cx":"32.195","cy":"24.447","r":"4.037"}}),_c('path',{attrs:{"d":"M43.334 39.452c-1.256-3.261-3.219-6.328-5.528-8.637a2.276 2.276 0 00-.624-.432l.001-.05c-.745-1-1.702-1.101-1.702-1.101l-6.522-.026s-.306-.008-.718.072c-3.465-1.832-3.646-5.823-3.083-9.088a2.285 2.285 0 00-1.864-2.641c-.112-.02-.221-.021-.331-.023L21.76 9.538l.819-.225-.617-.447c1.291-.658 2.083-2.546 1.841-4.664-.286-2.511-1.917-4.384-3.644-4.188-1.725.198-2.892 2.392-2.604 4.901.273 2.391 1.767 4.202 3.399 4.198l-.624.817.793-.219 1.188 7.887a2.283 2.283 0 00-1.662 1.814c-1.188 6.893 1.099 12.06 6.168 14.271l.479 5.97v4.515c0 .26.026.516.068.764-.002.05-.008.097-.008.146v13.479c0 1.348 1.006 2.439 2.245 2.439 1.238 0 2.241-1.093 2.241-2.439v-9.615c.078.005.158.013.238.013.078 0 .152-.007.229-.013v9.615c0 1.348 1.004 2.439 2.243 2.439 1.236 0 2.242-1.093 2.242-2.439V45.076c0-.033-.004-.063-.004-.095a4.87 4.87 0 00.073-.814v-4.246l.097-2.904a21.651 21.651 0 012.102 4.078 2.288 2.288 0 004.272-1.643z"}})])])
          )
        }
      }
    